import React from 'react';

interface SummaryCardProps {
  label: string;
  direction: string;
  value: number;
  pctString: string;
}

export default function SummaryCard({
  label,
  value,
  pctString,
  direction,
}: SummaryCardProps) {
  const colorClass =
    direction === 'up'
      ? 'text-green-600'
      : direction === 'down'
        ? 'text-red-600'
        : 'text-gray-500';
  return (
    <div className='bg-[#F5F5F5] pt-5 px-6 pb-6 rounded-[16px]'>
      <div className='text-button text-[#464646]'>{label}</div>
      <div className='flex flex-col lg:flex-row'>
        <div className='lg:text-[32px] leading-[49px] tracking-[0px] mr-2 font-[900]'>
          {value}
        </div>
        <div className={`self-start leading-[38px] lg:self-end ${colorClass}`}>
          {pctString}
        </div>
      </div>
    </div>
  );
}
